<template>
   <div class="text-img-section container mx-auto" data-cy="text-image-button-section">
      <div class="rounded-2xl md:flex md:rounded-3xl" :class="`theme-${containerTheme}`">
         <div class="flex flex-col p-4 pb-2 md:p-10 lg:p-12 xl:p-16" :class="{ 'md:w-6/12 md:pr-4': image }">
            <Kicker v-if="kicker" :text="kicker" class="w-fit" />

            <h3 v-if="heading" class="mb-3 mt-4 text-3xl">{{ heading }}</h3>
            <div class="leading-normal md:flex-1 lg:mb-0 lg:leading-relaxed xl:text-lg">
               <RichTextRenderer :document="description" />
            </div>

            <PageCTAItems
               v-if="ctas && ctas.length > 0"
               class="mt-10"
               :ctas="ctas"
               :theme="containerTheme"
               :isPageCta="true"
            />
         </div>

         <div
            v-if="image"
            class="flex flex-1 md:w-6/12"
            :class="[
               { 'items-end': imageVAlign === 'base' },
               { 'items-start': imageVAlign === 'top' },
               { 'items-center': imageVAlign === 'center' },
               { 'justify-center': imageHAlign === 'center' },
               { 'justify-start': imageHAlign === 'left' },
               { 'justify-end': imageHAlign === 'right' },
            ]"
         >
            <picture>
               <source :srcset="`${image.url.xl}`" media="(min-width: 992px)" />
               <img
                  :srcset="`${image.url.md}`"
                  class="w-full"
                  :class="[
                     { 'pt-10 md:pt-16': imageVAlign === 'base' },
                     { 'pb-10 md:pb-16': imageVAlign === 'top' },
                     { 'max-w-xs md:max-w-sm': imageMaxWidth === 'md' },
                     { 'max-w-xxs md:max-w-xs': imageMaxWidth === 'sm' },
                     { 'px-4 md:px-0': imageMaxWidth !== 'full' },
                  ]"
                  :alt="image.altTag || ''"
                  loading="lazy"
                  decoding="async"
               />
            </picture>
         </div>
      </div>
   </div>
</template>
<script setup lang="ts">
import type { PageSectionImage } from "../pagesection.type";
import type { CTAItemData } from "@/components/ui/buttons/PageCTAItems.vue";
import { type RichText, Theme, type ContainerTheme } from "@/types";

const props = withDefaults(
   defineProps<{
      heading: string;
      image?: PageSectionImage;
      imageVAlign?: "base" | "center" | "top";
      imageHAlign?: "left" | "center" | "right";
      imageMaxWidth?: "md" | "sm" | "full";
      margin?: string;
      kicker?: string;
      description?: RichText;
      ctas?: CTAItemData[];
      theme?: ContainerTheme;
   }>(),
   {
      theme: Theme.Grey,
      imageVAlign: "base",
      imageHAlign: "left",
      imageMaxWidth: "md",
   }
);

const containerTheme = computed(() => (props.theme ? props.theme : Theme.Grey));
</script>

<style lang="scss" scoped></style>
